import React from 'react'
import { Image, CtaArrow, Link } from 'newComponents'
import './styles.scss'

const MidBodyBanner = ({ data }) => {
  const {
    primary: { banner_icon: icon, banner_title: title, banner_cta_text: ctaText, banner_cta_url: ctaUrl }
  } = data[0]

  return (
    <div className="mid-body-banner">
      <div className="container">
        <Link className="mid-body-banner-cta" to={ctaUrl.url}>
          <div className="mid-body-banner-wrapper">
            <Image className="mid-body-banner-icon" image={icon} />
            <h6>{title.text}</h6>
            <span>
              {ctaText.text} <CtaArrow />
            </span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default MidBodyBanner
